import React from "react";
import HeaderInner from "../header/HeaderInner";
import Breadcrumb from "../inner/Breadcrumb";
import ServiceOne from "../elements/ServiceOne";
import WorkingProcess from "../elements/WorkingProcess";
import WhychooseUs from "../elements/WhychooseUs";
import CallToAction from "../elements/CallToAction";
import Footer from "../elements/Footer";

// DATA
// import { DataServicePageSec1 } from "../data/DataService";
import { dataWorkingProcess } from "../data/DataWorkingProcess";
import { DataAboutServicePageSec3 } from "../data/DataAbout";
import { DataContactOne } from "../data/DataContact";
import { DataNav } from "../data/DataNav";

function Service() {
  const dataBreadcrumb = DataNav[2];

  return (
    <div className="">
      <HeaderInner />
      <main>
        <Breadcrumb props={dataBreadcrumb} />
        {/* <ServiceOne dataService={DataServicePageSec1} /> */}
        <WhychooseUs dataAbout={DataAboutServicePageSec3} />
        <WorkingProcess dataWorkingProcess={dataWorkingProcess} />
        <CallToAction dataContact={DataContactOne} />
        <Footer />
      </main>
    </div>
  );
}

export default Service;
